import { useSEO } from "../../hooks/useSEO";
import Header from "./Header";
import Hero from "./Hero";
import HowItWorks from "./HowItWorks";
import Stats from "./Stats";
import UseCases from "./UseCases";
import ConsejoAsesor from "./ConsejoAsesor";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

export default function LandingPage() {
  useSEO({
    title: 'Conadvy — Infraestructura privada de decisión estratégica',
    description: 'Conectamos empresas con advisors de primer nivel. Acceso a experiencia directiva senior bajo protocolo de confidencialidad, sin compromiso fijo.',
    path: '/',
  });
  return (
    <>
      <Header variant="landing" />
      <main>
        <Hero />
        <HowItWorks />
        <Stats />
        <UseCases />
        <ConsejoAsesor />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
